import Vue from 'vue'
import Router from 'vue-router'
import VueSwal from 'vue-swal'

import Index from '@/components/Index'
import Purchase from '@/components/purchase'
import Privacy from '@/components/privacy'
import Airtel from '@/components/airtel'
import History from '@/components/history'
import Offers from '@/components/offers'
import Offer from '@/components/offer'
import Blogs from '@/components/blogs'
import Blog from '@/components/blog'
import Auth from '@/components/auth'


Vue.use(Router)
Vue.use(VueSwal)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: Purchase
    },
    {
      path: '/purchase.pinless',
      name: 'purchase.pinless',
      component: Purchase
    },

    {
      path: '/privacy-policy',
      name: 'privacy',
      component: Privacy
    },
     {
      path: '/airtel',
      name: 'airtel',
      component: Airtel
    },
      {
      path: '/history',
      name: 'history',
      component: History
    },
    {
      path: '/offers',
      name: 'offers',
      component: Offers
    },
     {
      path: '/offer/:id',
      name: 'offer',
      component: Offer
    },
     {
      path: '/blogs',
      name: 'blogs',
      component: Blogs
    },
    {
      path: '/blog:id',
      name: 'blog',
      component: Blog
    },
     {
      path: '/auth',
      name: 'auth',
      component: Auth
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js